module.exports = __webpack_public_path__ + "components/rewards/app/static/logo-21de7bbeb65e1193e7c0cfd8f2bf469e.webp";